import styled from 'styled-components';

export const Root = styled.div`
  --bg: #f5f7fb;
  --card: #ffffff;
  --text: #111827;
  --muted: #6b7280;
  --border: #e5e7eb;
  --primary: #111827;
  --danger: #dc2626;

  /* was body { } in the original — now applied to the isolated root */
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  background: var(--bg);
  color: var(--text);

  * {
    box-sizing: border-box;
  }

  .page {
    max-width: 1280px;
    margin: 0 auto;
    padding: 28px;
  }

  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
  }

  .header h1 {
    margin: 0 0 10px;
    font-size: 46px;
    letter-spacing: -0.04em;
  }

  .header p {
    margin: 0;
    color: var(--muted);
    font-size: 16px;
  }

  .btn {
    border: 0;
    border-radius: 16px;
    padding: 14px 18px;
    font-size: 15px;
    font-weight: 800;
    cursor: pointer;
    background: var(--primary);
    color: white;
    min-height: 48px;
  }

  .btn.secondary {
    background: #f3f4f6;
    color: var(--text);
    border: 1px solid var(--border);
  }

  .filters {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 24px;
    padding: 20px;
    margin-bottom: 22px;
    box-shadow: 0 8px 22px rgba(17, 24, 39, 0.04);
  }

  label {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: var(--muted);
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  select,
  input,
  textarea {
    width: 100%;
    border-radius: 16px;
    border: 1px solid var(--border);
    padding: 0 16px;
    font-size: 16px;
    background: white;
    color: var(--text);
  }

  select,
  input {
    height: 56px;
  }

  textarea {
    min-height: 120px;
    padding-top: 14px;
    resize: vertical;
    font-family: Arial, Helvetica, sans-serif;
  }

  .kpis {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
    margin-bottom: 22px;
  }

  .card {
    background: white;
    border: 1px solid var(--border);
    border-radius: 24px;
    padding: 26px;
    box-shadow: 0 8px 22px rgba(17, 24, 39, 0.04);
  }

  .kpi-title {
    color: #64748b;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 18px;
  }

  .kpi-value {
    font-size: 52px;
    font-weight: 800;
    letter-spacing: -0.05em;
  }

  @keyframes skeleton-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }
  .skeleton {
    background: #e5e7eb;
    border-radius: 8px;
    animation: skeleton-pulse 1.4s ease-in-out infinite;
    display: inline-block;
  }
  .kpi-value.loading {
    color: transparent;
    position: relative;
  }
  .kpi-value.loading::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 80px;
    height: 44px;
    background: #e5e7eb;
    border-radius: 8px;
    animation: skeleton-pulse 1.4s ease-in-out infinite;
  }
  .kpi-title.loading {
    color: transparent;
    position: relative;
  }
  .kpi-title.loading::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 120px;
    height: 14px;
    background: #e5e7eb;
    border-radius: 4px;
    animation: skeleton-pulse 1.4s ease-in-out infinite;
  }
  .skeleton-row td {
    color: transparent !important;
    background: #f3f4f6;
  }
  .skeleton-row td::after {
    content: '—————————';
    color: #e5e7eb;
  }

  .grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 22px;
    margin-bottom: 22px;
  }

  .section-title {
    font-size: 22px;
    margin: 0 0 20px;
    font-weight: 800;
    letter-spacing: -0.03em;
  }

  .tables {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 22px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th,
  td {
    text-align: left;
    padding: 12px 8px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    vertical-align: top;
  }

  th {
    color: #64748b;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.03em;
  }

  .pill {
    display: inline-block;
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .pill.green {
    background: #dcfce7;
    color: #166534;
  }
  .pill.red {
    background: #fee2e2;
    color: #991b1b;
  }
  .pill.yellow {
    background: #fef3c7;
    color: #92400e;
  }
  .pill.blue {
    background: #dbeafe;
    color: #1e40af;
  }
  .pill.purple {
    background: #ede9fe;
    color: #5b21b6;
  }
  .pill.gray {
    background: #f3f4f6;
    color: #374151;
  }
  .muted {
    color: var(--muted);
  }

  .modal-overlay {
    position: fixed;
    inset: 0;
    display: none;
    align-items: center;
    justify-content: center;
    background: rgba(15, 23, 42, 0.58);
    padding: 20px;
    z-index: 9999;
  }

  .modal-overlay.open {
    display: flex;
  }

  .modal {
    width: min(760px, 100%);
    max-height: 92vh;
    overflow: auto;
    background: white;
    border-radius: 26px;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.25);
    border: 1px solid var(--border);
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
    padding: 24px 26px 12px;
    border-bottom: 1px solid var(--border);
  }

  .modal-header h2 {
    margin: 0 0 6px;
    font-size: 26px;
    letter-spacing: -0.03em;
  }

  .modal-header p {
    margin: 0;
    color: var(--muted);
    font-size: 14px;
  }

  .close-btn {
    border: 0;
    background: #f3f4f6;
    color: #111827;
    border-radius: 14px;
    width: 42px;
    height: 42px;
    font-size: 24px;
    cursor: pointer;
  }

  .modal-body {
    padding: 22px 26px 26px;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .form-grid .full {
    grid-column: 1 / -1;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 22px;
  }

  .message {
    display: none;
    margin-top: 14px;
    padding: 12px 14px;
    border-radius: 14px;
    font-weight: 700;
    font-size: 14px;
  }

  .message.success {
    display: block;
    background: #dcfce7;
    color: #166534;
  }
  .message.error {
    display: block;
    background: #fee2e2;
    color: #991b1b;
  }

  .section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 20px;
  }

  .section-head .section-title {
    margin: 0;
  }

  .btn.small {
    min-height: 38px;
    padding: 9px 13px;
    font-size: 13px;
    border-radius: 12px;
  }

  .records-modal {
    width: min(1180px, 100%);
    max-height: 92vh;
    overflow: auto;
    background: white;
    border-radius: 26px;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.25);
    border: 1px solid var(--border);
  }

  .records-toolbar {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 1fr 1fr 0.8fr 0.8fr auto;
    gap: 12px;
    margin-bottom: 18px;
    align-items: end;
  }

  .records-table-wrap {
    overflow: auto;
    border: 1px solid var(--border);
    border-radius: 18px;
  }

  .records-table {
    min-width: 1450px;
  }

  .records-table th,
  .records-table td {
    white-space: normal;
    vertical-align: top;
  }

  @media print {
    & * {
      visibility: hidden !important;
    }
    #recordsModal,
    #recordsModal * {
      visibility: visible !important;
    }
    #recordsModal {
      position: absolute !important;
      inset: 0 !important;
      display: block !important;
      background: white !important;
      padding: 0 !important;
    }
    .records-modal {
      width: 100% !important;
      max-height: none !important;
      box-shadow: none !important;
      border: none !important;
      border-radius: 0 !important;
    }
    .close-btn,
    .modal-actions,
    .records-toolbar,
    .btn {
      display: none !important;
    }
  }

  .partners-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .partners-list-wrap {
    overflow: auto;
    border: 1px solid var(--border);
    border-radius: 18px;
    margin-bottom: 20px;
  }

  .partners-table {
    min-width: 980px;
  }

  .partner-form {
    border-top: 1px solid var(--border);
    padding-top: 20px;
    margin-top: 8px;
    display: none;
  }

  .partner-form.open {
    display: block;
  }

  @media (max-width: 900px) {
    .filters,
    .kpis,
    .grid,
    .tables,
    .form-grid,
    .records-toolbar {
      grid-template-columns: 1fr;
    }
    .form-grid .full {
      grid-column: auto;
    }
    .header {
      flex-direction: column;
    }
    .header h1 {
      font-size: 36px;
    }
    .page {
      padding: 18px;
    }
    .modal-actions {
      flex-direction: column-reverse;
    }
    .btn {
      width: 100%;
    }
  }
`;
